import {
    GET_CUTOFF_LUNCH_MENU_WATCHER, SAVE_CUTOFF_LUNCH_MENU_WATCHER, DELETE_CUTOFF_LUNCH_MENU_WATCHER, CUTOFF_LUNCH_MENU_LIST,
    GET_CUTOFF_SCHEDULE_WATCHER, SAVE_CUTOFF_SCHEDULE_WATCHER, TOGGLE_CUTOFF_SCHEDULE_WATCHER, GENERATE_CUTOFF_SCHEDULE_WATCHER,
    DELETE_CUTOFF_SCHEDULE_WATCHER, CUTOFF_SCHEDULE_LIST
} from "../../actionTypes/admin";

export function getCutoffLunchMenuWatcher() {
    return { type: GET_CUTOFF_LUNCH_MENU_WATCHER };
}

export function saveCutoffLunchMenuWatcher(data, setOpen) {
    return { type: SAVE_CUTOFF_LUNCH_MENU_WATCHER, payload: data, setOpen };
}

export function deleteCutoffLunchMenuWatcher(id) {
    return { type: DELETE_CUTOFF_LUNCH_MENU_WATCHER, id };
}

export function cutoffLunchMenuList(data) {
    return { type: CUTOFF_LUNCH_MENU_LIST, payload: data };
}

// Schedules (daily / recurring, automatic or manual)
export function getCutoffScheduleWatcher() {
    return { type: GET_CUTOFF_SCHEDULE_WATCHER };
}

export function saveCutoffScheduleWatcher(data, setOpen) {
    return { type: SAVE_CUTOFF_SCHEDULE_WATCHER, payload: data, setOpen };
}

export function toggleCutoffScheduleWatcher(id, isActive) {
    return { type: TOGGLE_CUTOFF_SCHEDULE_WATCHER, id, isActive };
}

export function generateCutoffScheduleWatcher(id) {
    return { type: GENERATE_CUTOFF_SCHEDULE_WATCHER, id };
}

export function deleteCutoffScheduleWatcher(id) {
    return { type: DELETE_CUTOFF_SCHEDULE_WATCHER, id };
}

export function cutoffScheduleList(data) {
    return { type: CUTOFF_SCHEDULE_LIST, payload: data };
}
